import {
  Modal as ChakraModal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Text
} from '@chakra-ui/react'
import { QRCodeSVG } from 'qrcode.react'
import { useEffect, useState } from 'react'

interface IProps {
  isOpen: boolean
  onClose: () => void
  textHeader: string
  code: string
}

export function AbraMidiaInfoModal({ isOpen, onClose, textHeader, code }: IProps) {
  const [qrCodeValue, setQRCodeValue] = useState('https://painel.abra.com.br/abra-midia/visualizar')

  useEffect(() => {
    setQRCodeValue(`https://painel.abra.com.br/abra-midia/visualizar/${code}`)
  }, [code])

  return (
    <ChakraModal isOpen={isOpen} onClose={onClose} size="sm">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{textHeader}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <QRCodeSVG value={qrCodeValue} size={600} style={{ width: '70%', height: 'auto', margin: 'auto' }} />
          <Text fontSize="sm" mt="5" mb="2">
            Escaneie o QRCode acima para acessar automaticamente a mídia ou acesse:
          </Text>
          <Text
            fontSize="md"
            fontWeight="bold"
            textAlign="center"
            color={'magenta.100'}
            backgroundColor="magenta.400"
            p="3"
            borderRadius="md"
          >
            painel.abra.com.br/abra-midia/visualizar
          </Text>
          <Text fontSize="sm" mt="2" mb="2">
            E insira o código abaixo:
          </Text>
          <Text
            fontSize="md"
            fontWeight="bold"
            textAlign="center"
            color={'magenta.100'}
            backgroundColor="magenta.400"
            p="3"
            borderRadius="md"
            mb="5"
          >
            Código: {code}
          </Text>
        </ModalBody>
      </ModalContent>
    </ChakraModal>
  )
}
